export class Controller {

	/** @ngInject */
	constructor($state, Alert, SharedAccountsService, CompanyUser) {
		this.$state = $state;
		this.Alert = Alert;
		this.SharedAccountsService = SharedAccountsService;
		this.CompanyUser = CompanyUser;
	}

	$onInit() {
		this.importResult = this.$state.params.importResult;
		if (this.importResult == null) {
			this.close();
		}
		this.labels$.get().then((labels) => this.labels=labels);
		this.selectedLabels = [];
		this.showPasswordEnabled = false;
		this.showOtpEnabled = false;
		this.showNoteEnabled = false;
		this.companyUsers = [];

	}

	isCheckedLabel(label) {
		var indexOfLabel = this.selectedLabels.indexOf(label);
		return indexOfLabel >= 0;
	}

	isCheckboxDisabled(label) {
		var isIt = (label.name !== "ALL_USERS") && (this.selectedLabels.length == 1) && (this.selectedLabels[0].name === "ALL_USERS");
		return isIt;
	}
	clickLabel(label) {
		var indexOfLabel = this.selectedLabels.indexOf(label);
		if (indexOfLabel >= 0) {
			this.selectedLabels.splice(indexOfLabel, 1)
		} else {
			if (label.name === "ALL_USERS") {
				this.selectedLabels = [];
			}
			this.selectedLabels.push(label);
		}
	}
	clearSearch() {
		this.successResult = false;
		this.companyUser=null;
		this.newUserIdentifier=null;
		this.showClear=false;
	}
	
	identifyUser() {
		this.successResult = false;
		this.companyUser = null;
		this.message = null;
		this.CompanyUser.identifyCompanyUser({
			companyId: this.companyId,
			uid: encodeURIComponent(this.newUserIdentifier)
		}).$promise
			.then((response) => {
				this.companyUser = response;
				this.companyUser.selected = true;
				this.companyUsers.push(this.companyUser);
				this.message = 'groups_users.user_found';
				this.successResult = true;
			})
			.catch((error) => { 
				console.log(error); 
				if (error.status == 404) {
                                this.message = 'groups_users.user_not_found';
                            } else {
                                this.message = error.message;
                            }
			})
			.finally(()=>{this.showClear=true;});
	}

	getSelectedSaaspassUsersIds() {
		return this.companyUsers.filter((user) => user.selected).map((user) => user.saaspassUser.id);
	}

	checkboxChange(cUser) {
		var foundIndex = this.companyUsers.findIndex(x => x.id == cUser.id);
		this.companyUsers[foundIndex].selected = (!cUser.selected);
		console.log(this.companyUsers);
	}
	
	save() {
		var saaspassUsersIds = this.getSelectedSaaspassUsersIds();
		if (this.selectedLabels.length == 0 && !this.showPasswordEnabled && this.companyUsers.length == 0) {
			this.close();
		} else {
			this.SharedAccountsService.updateAndShareServiceAccountsWithLabels({
				companyId: this.companyId,
				showPassword: this.showPasswordEnabled,
				showOtp: this.showOtpEnabled,
				showNote: this.showNoteEnabled
				
				
			}, { labels: this.selectedLabels, corporateServiceAccountIds: this.importResult.importedIds, spUsersIds: saaspassUsersIds, labelsToUnshare: [] })
				.$promise
				.then(() => {
					this.close();
					this.Alert('success', 'company.sharing-center.shared-passwords.import-csv.import-completed.success')

				})
				.catch(error => {
					console.log(error);
					this.Alert('danger', error.message);
				});
		}

	}
	close() {
		this.$state.go('company.sharing-center.shared-passwords', {}, { reload: true });
	}
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/import-csv/import-completed/import-completed.controller.js